export const modalSelector = (state) => state.modal;
export const settingsSelector = (state) => state.settings;
export const filtersSelector = (state) => state.filters;
export const firebaseSelector = (state) => state.firebase;
